// One labelled value in a phone patient card's two-column grid (Antrian Kamar, Jadwal Pasien).
export default function CardField({ label, children, className = "" }) {
  return (
    <div className={`min-w-0 ${className}`}>
      <dt className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">{label}</dt>
      <dd className="mt-0.5 text-sm text-slate-700 break-words">{children}</dd>
    </div>
  );
}
